module.exports = __webpack_public_path__ + "static/img/DSC02521.36365c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DSC02521.jpg
// module id = lypt
// module chunks = 0